 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"charts":"charts"}[chunkId]||chunkId) + "." + {"charts":"a170e3f8","chunk-13ac5475":"719e6788","chunk-1d64e68c":"55b0c939","chunk-1dbf09f6":"e022917e","chunk-248b39c2":"94b3a58c","chunk-f5770d90":"895c85a1","chunk-2656147d":"752dad56","chunk-29aa641b":"5a924523","chunk-39344a1e":"a332d654","chunk-404b9492":"94ec65fa","chunk-9563de00":"dd51f8ae","chunk-b1d2e416":"150d4741","chunk-c73c49c2":"a26c33a5","chunk-d395b478":"b434a6a5","chunk-ee9e7e78":"cb655eb0","chunk-147e1359":"1088c2b8","chunk-675407de":"1f66abe1","chunk-2d215cc2":"66711001","chunk-2e3caba6":"8d726896","chunk-7a72f8db":"395a2528","chunk-adf92472":"5e45f2d1","chunk-3036f0b5":"0b9ca9bb","chunk-3e44dc98":"5ddc0e2a","chunk-45718c5c":"0dec815e","chunk-4920329e":"4f78e35f","chunk-4aecb497":"b33277a0","chunk-50adf8bd":"73881fb1","chunk-5428c056":"744dbe41","chunk-5c26c247":"c279d9f7","chunk-5c5a8006":"908314b4","chunk-60e8c654":"e201a181","chunk-67d4bade":"49d22660","chunk-705e669c":"ab6cbf00","chunk-8ceb33de":"5f1ecf68","chunk-a1fccc96":"0ca60361","chunk-e368056c":"66d50340","chunk-2d0a36c7":"9dbe088f","chunk-2d0a3c1f":"bc8b6cf8","chunk-2d0ab480":"1ac034ed","chunk-2d0b34ac":"258b02a6","chunk-2d0b5f3c":"da6a49a3","chunk-2d0b6caf":"81393fb9","chunk-2d0b9a2e":"8e3797d3","chunk-2d0c537a":"a260ad8d","chunk-2d0ce7ac":"c50680fc","chunk-2d0d0b7b":"f4661869","chunk-2d0d7101":"328124f1","chunk-2d0daa8b":"3f112200","chunk-2d0e5f23":"88daf914","chunk-2d0ea0d6":"0fff3dea","chunk-2d0f0b74":"00d4dd01","chunk-2d216b94":"af60da0b","chunk-2d218000":"179f0429","chunk-2d218020":"5e1ac549","chunk-2d219f7b":"0be441a1","chunk-2d21d4e4":"2deb222c","chunk-2d21df85":"0e7a650f","chunk-2d221da3":"74cb0eec","chunk-2d2245ac":"8a45d475","chunk-2d23712f":"e44221fe","chunk-3f88fe67":"b32e8dca"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"charts":1,"chunk-13ac5475":1,"chunk-1d64e68c":1,"chunk-1dbf09f6":1,"chunk-248b39c2":1,"chunk-f5770d90":1,"chunk-2656147d":1,"chunk-29aa641b":1,"chunk-39344a1e":1,"chunk-404b9492":1,"chunk-9563de00":1,"chunk-b1d2e416":1,"chunk-c73c49c2":1,"chunk-d395b478":1,"chunk-ee9e7e78":1,"chunk-147e1359":1,"chunk-675407de":1,"chunk-2e3caba6":1,"chunk-7a72f8db":1,"chunk-adf92472":1,"chunk-3036f0b5":1,"chunk-3e44dc98":1,"chunk-45718c5c":1,"chunk-4920329e":1,"chunk-4aecb497":1,"chunk-50adf8bd":1,"chunk-5428c056":1,"chunk-5c26c247":1,"chunk-5c5a8006":1,"chunk-60e8c654":1,"chunk-67d4bade":1,"chunk-705e669c":1,"chunk-8ceb33de":1,"chunk-a1fccc96":1,"chunk-e368056c":1,"chunk-3f88fe67":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"charts":"charts"}[chunkId]||chunkId) + "." + {"charts":"b0e58064","chunk-13ac5475":"b4cbfd87","chunk-1d64e68c":"29cc45f2","chunk-1dbf09f6":"63125d92","chunk-248b39c2":"573a88ef","chunk-f5770d90":"03199cbd","chunk-2656147d":"c400bdfa","chunk-29aa641b":"b86bc29a","chunk-39344a1e":"4004bd3a","chunk-404b9492":"32fd9a9f","chunk-9563de00":"7d2521e8","chunk-b1d2e416":"f8915937","chunk-c73c49c2":"6dfdb4b3","chunk-d395b478":"d87ec168","chunk-ee9e7e78":"868b5ac9","chunk-147e1359":"fcd3e45d","chunk-675407de":"6aeb1564","chunk-2d215cc2":"31d6cfe0","chunk-2e3caba6":"180c9ee3","chunk-7a72f8db":"3cffcfd1","chunk-adf92472":"e07d0d88","chunk-3036f0b5":"c09a6ca6","chunk-3e44dc98":"ec11672b","chunk-45718c5c":"0fb2838f","chunk-4920329e":"a7f4d31f","chunk-4aecb497":"8f8466e0","chunk-50adf8bd":"8da50ad8","chunk-5428c056":"adbcf929","chunk-5c26c247":"fe20c699","chunk-5c5a8006":"b2ce88c6","chunk-60e8c654":"23b43c06","chunk-67d4bade":"d9fb75c6","chunk-705e669c":"3d0737d5","chunk-8ceb33de":"89ea01a4","chunk-a1fccc96":"733c7303","chunk-e368056c":"6b48f067","chunk-2d0a36c7":"31d6cfe0","chunk-2d0a3c1f":"31d6cfe0","chunk-2d0ab480":"31d6cfe0","chunk-2d0b34ac":"31d6cfe0","chunk-2d0b5f3c":"31d6cfe0","chunk-2d0b6caf":"31d6cfe0","chunk-2d0b9a2e":"31d6cfe0","chunk-2d0c537a":"31d6cfe0","chunk-2d0ce7ac":"31d6cfe0","chunk-2d0d0b7b":"31d6cfe0","chunk-2d0d7101":"31d6cfe0","chunk-2d0daa8b":"31d6cfe0","chunk-2d0e5f23":"31d6cfe0","chunk-2d0ea0d6":"31d6cfe0","chunk-2d0f0b74":"31d6cfe0","chunk-2d216b94":"31d6cfe0","chunk-2d218000":"31d6cfe0","chunk-2d218020":"31d6cfe0","chunk-2d219f7b":"31d6cfe0","chunk-2d21d4e4":"31d6cfe0","chunk-2d21df85":"31d6cfe0","chunk-2d221da3":"31d6cfe0","chunk-2d2245ac":"31d6cfe0","chunk-2d23712f":"31d6cfe0","chunk-3f88fe67":"f86e7a81"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
